/**
 * 特斯拉记录数据菜单
 */
export default [

  {
    label: 'teslaCustom',  // 特斯拉记录数据
    permission: 'tesla_custom_record',
    img: true,
    id: 15,
    icon: 'icon-yonghu',
    children: [
      {
        path: '/tesla/customRecord/index',
        label: 'teslaCustomData',   // 特斯拉记录数据
        permission: 'tesla_custom_record_index',
        id: '15-1',
        icon: 'icon-yonghu',
      },
      {
        path: '/tesla/financialStatements/index',
        label: 'teslaPayAccount',   // 工资记账报表
        permission: 'tesla_pay_accounting_report',
        id: '15-2',
        icon: 'icon-yonghu',
      }
    ]
  }
]
